(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("interactive-vector-layer", [], factory);
	else if(typeof exports === 'object')
		exports["interactive-vector-layer"] = factory();
	else
		root["interactive-vector-layer"] = factory();
})(self, function() {
return 